import React from "react";
import { Button, ButtonGroup, Box, Paper } from "@mui/material";
import PropTypes from "prop-types";

export const TradeButtons=({getRandomData, sendAttempt, isLoading}) => {
    return (
        <Box
          sx={{
            position: 'fixed',
            left: '50%',
            transform: 'translateX(-50%)',
            bottom: 16,
            zIndex: 1400,
            // On medium+ screens, dock to bottom-right
            '@media (min-width:900px)': {
              left: 24,
              transform: 'none',
              bottom: 24,
            }
          }}
          id="tv-trade-buttons"
          role="region"
          aria-label="trade action controls"
        >
          <Paper elevation={2} sx={{ p: { xs: 0.5, sm: 1 }, borderRadius: 2, bgcolor: 'background.paper', backdropFilter: 'blur(4px)' }}>
            <ButtonGroup
              disableElevation
              variant="contained"
              aria-label="trade action buttons"
              size="large"
            >
              <Button 
                color="inherit"
                onClick={getRandomData}
                disabled={isLoading}
                sx={{ px: { xs: 1.5, sm: 2 }, fontSize: { xs: 12, sm: 12 } }}
              >
                New
              </Button>
              <Button 
                color="primary"
                onClick={() => sendAttempt("buy")}
                disabled={isLoading}
                sx={{ px: { xs: 2, sm: 3 }, fontSize: { xs: 16, sm: 16 } }}
              >
                Buy
              </Button>
              <Button 
                color="secondary"
                onClick={() => sendAttempt("sell")}
                disabled={isLoading}
                sx={{ px: { xs: 2, sm: 3 }, fontSize: { xs: 16, sm: 16 } }}
              >
                Sell
              </Button>
            </ButtonGroup>
          </Paper>
        </Box>
    );
  }

TradeButtons.propTypes = {
    getRandomData: PropTypes.func,
    sendAttempt: PropTypes.func,
    isLoading: PropTypes.bool,
};
